<template>
  <v-container fluid grid-list-xl>
    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div v-responsive.lg.xl>
      <div>
        <!--PARTIE POURQUOI CHOISIR ASSURAF-->
        <div style="background: #ffffff;height:auto">
          <div class="justify-content-center column pt-5">
            <div class="justify-content-center row">
              <h1 class="justify-content-center row titre_for_desktop">{{ $t('home_page.pourquoi_assuraf') }}</h1>
            </div>

            <div class="justify-content-center row">
              <v-toolbar class="justify-content-center row underline_bar"></v-toolbar>
            </div>

            <div class="justify-content-center row pb-5 pt-5">
              <h4 class="font-weight-bold text-center" style="color:#ffa409">
                {{ $t('home_page.texte_intro') }}
              </h4>
            </div>

            <div class="justify-content-center row">
              <v-flex xs2 class="justify-content-center row mr-3">
                <v-flex class="justify-content-center column">
                  <div class="justify-content-center row">
                    <p class="justify-content-center row"><img   src="../../assets/img/number/1.png" alt="numéro un" width="60"
                                                               height="60"></p>
                  </div>
                  <div class="justify-content-center column">
                    <p class="justify-content-center row" style="font-size:18px;color: #272626">{{
                        $t('home_page.un[0]')
                      }}</p>
                    <p class="justify-content-center row" style="font-size:18px;margin-top: -4%;color: #272626">
                      {{ $t('home_page.un[1]') }}</p>
                  </div>
                </v-flex>
              </v-flex>
              <v-divider class="orange" vertical inset></v-divider>


              <v-flex xs2 class="justify-content-center row">
                <v-flex class="justify-content-center column">
                  <div class="justify-content-center row">
                    <p class="justify-content-center row"><img   src="../../assets/img/number/2.png" alt="numero deux" width="60"
                                                               height="60"></p>
                  </div>
                  <div class="justify-content-center column">
                    <p class="justify-content-center row" style="font-size:18px;color:#272626">
                      {{ $t('home_page.deux[0]') }}</p>
                    <p class="justify-content-center row" style="font-size:18px;margin-top: -4%;color:#272626">
                      {{ $t('home_page.deux[1]') }}</p>
                  </div>
                </v-flex>
              </v-flex>
              <v-divider class="orange" vertical inset></v-divider>

              <v-flex xs2 class="justify-content-center row">
                <v-flex class="justify-content-center column">
                  <div class="justify-content-center row">
                    <p class="justify-content-center row"><img   src="../../assets/img/number/3.png" alt="numero trois" width="60"
                                                               height="60"></p>
                  </div>
                  <div class="justify-content-center row">
                    <p class="justify-content-center row" style="font-size:18px;color:#272626">
                      <span>{{ $t('home_page.trois') }}<br></span>

                    </p>
                  </div>
                </v-flex>
              </v-flex>
              <v-divider class="orange" vertical inset></v-divider>

              <v-flex xs2 class="justify-content-center row">
                <v-flex class="justify-content-center column">
                  <div class="justify-content-center row">
                    <p class="justify-content-center row"><img   src="../../assets/img/number/4.png" alt="numero quatre" width="60"
                                                               height="60"></p>
                  </div>
                  <div class="justify-content-center column">
                    <p class="justify-content-center row" style="font-size:18px;color:#272626">
                      {{ $t('home_page.quatre[0]') }}</p>
                    <p class="justify-content-center row" style="font-size:18px;margin-top: -4%;color:#272626">
                      {{ $t('home_page.quatre[1]') }}</p>
                  </div>
                </v-flex>
              </v-flex>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE      =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div style="margin-top:50px" v-responsive.sm.xs>
      <div>
        <!--PARTIE POURQUOI CHOISIR ASSURAF-->
        <div style="background: #ffffff;height: auto">
          <div class="justify-content-center column pt-5 pb-4">
            <div class="justify-content-center row">
              <h1 class="justify-content-center row titre_for_desktop" style="font-size: 20px">
                {{ $t('home_page.pourquoi_assuraf') }}</h1>
            </div>
            <div class="justify-content-center row">
              <v-toolbar class="justify-content-center row underline_bar"></v-toolbar>
            </div>

            <div class="justify-content-center row pt-5 mr-4 ml-4">
              <p class="font-weight-bold text-center" style="color:#ffa409">
                {{ $t('home_page.texte_intro') }}
              </p>
            </div>

            <v-flex class="column">
              <v-flex class="ml-4">
                <p style="color:#272626;">
                  <img   class="pr-2" src="../../assets/img/number/1.png" width="50" alt="numero un">
                  {{ $t('home_page.un_mobile') }}
                </p>

                <p style="color:#272626;">
                  <img   class="pr-2" src="../../assets/img/number/2.png" width="50" alt="numero deux">
                  {{ $t('home_page.deux_mobile') }}
                </p>

                <p style="color:#272626;">
                  <img   class="pr-2" src="../../assets/img/number/3.png" width="50" alt="numero trois">
                  {{ $t('home_page.trois_mobile') }}
                </p>

                <p style="color:#272626;">
                  <img   class="pr-2" src="../../assets/img/number/4.png" width="50" alt="numero quatre">
                  {{ $t('home_page.quatre_mobile') }}
                </p>
              </v-flex>
            </v-flex>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import simplebar from 'simplebar-vue';
import 'simplebar/dist/simplebar.min.css';

export default {
  name: 'pourquoi_section',
  components: {
    simplebar
  },
  data: () => ({
    title: 'Assuraf',
    description: 'Le meilleur de l\'assurance en ligne au Sénégal. Faites votre devis, souscrivez et payez en ligne: vous êtes assuré ! Un service simple, une offre claire et complète, une expérience proactive et multicanale.'
  }),
  metaInfo() {
    return {
      title: this.title,
      meta: [{
        charset: 'utf-8'
      },
        {
          name: 'description',
          content: this.description
        }
      ]
    }
  },

  mounted() {
  window.scrollTo(0, 0);  
  }
}
</script>

<style lang="less" scoped>

@import "../../assets/less/config";
@import "../../assets/css/button.css";

@keyframes header-animation {
  from {
    transform: translate3d(0, -100%, 0);
    opacity: 0;
  }
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

.underline_bar {
  height: 4px;
  width: 150px;
  background: #ffa409;
}

.titre_for_desktop {
  color: #2b2b2b;
  font-size: 25px;
  font-weight: bold;
  text-align: center;
}

.margin {
  margin-left: 8%;
  margin-right: 8%;
}

.margin_mobile {
  margin-left: 5%;
  margin-right: 5%;
}

.margin-titre {
  margin-top: 48px;
  padding-bottom: 48px;
}

a, button {
  outline: none;
  cursor: pointer;
}

img {
  max-width: 100%;
}


h1 {
  font-weight: 100;
  font-size: 58px;
}

h2 {
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
}

h3 {
  font-size: 20px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 40px;
}

h1, h2 {
  margin: 0 0 20px;
  color: #fff;
}

p {
  font-size: 14px;
}

.col {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}


html {
background: #292929;
color: #edebeb;
padding: 1rem;
}




</style>

